import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesMetricsQuery } from "../graphql/queries";
import type {
  AnalyticsSalesMetricsQueryType,
  AnalyticsSalesMetricsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesMetricsQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesMetricsQueryType,
    AnalyticsSalesMetricsQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesMetricsQueryType,
    AnalyticsSalesMetricsQueryVariablesType
  >(AnalyticsSalesMetricsQuery, options);
};
